var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1534,
    height: 942,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillOpacity: 0.3,
    d: "M0 4h1534v938H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "#FFC3AB"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m690.015-7.215.006 969.983 144.991-.004-.006-969.983-144.991.004z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m690.015 363.533.002 227.142 144.993-.005-.001-227.141-144.994.004z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "m690.015 590.675.003 368.576 144.976-.004-.003-368.576-144.976.004z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m-269.881 959.688 959.91-.013L690.016-4h-.566c-529.832.003-959.338 431.464-959.331 963.688z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m97.144 960.191 592.886-.008-.008-596.65h-.352c-157.195.051-307.932 62.942-419.052 174.836-111.12 111.895-173.52 263.628-173.474 421.822z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m323.005 959.586 367.025-.005-.005-368.906h-.219c-97.312.031-190.626 38.915-259.414 108.099-68.788 69.185-107.417 163.001-107.387 260.812z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m1198.69-1.864-363.709.005.004 365.578h.217c96.434-.031 188.908-38.565 257.078-107.125 68.16-68.56 106.44-161.53 106.41-258.458z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m1198.69-1.856 223.82-.008c.05 156.838-61.79 307.27-171.91 418.205-110.11 110.936-259.491 173.287-415.268 173.338h-.349l-.003-225.776h.217c96.434-.03 188.903-38.582 257.073-107.173 68.17-68.591 106.45-161.603 106.42-258.576v.005-.015z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m1198.69-1.856 223.82-.008c.05 156.838-61.79 307.27-171.91 418.205-110.11 110.936-259.491 173.287-415.268 173.338h-.349l-.003-225.776h.217c96.434-.03 188.903-38.582 257.073-107.173 68.17-68.591 106.45-161.603 106.42-258.576v.005-.015z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m1422.66-1.86 363.8-.004c.01 527.697-425.73 955.49-950.914 955.492h-.561l-.005-363.904h.349c155.816-.05 305.231-62.406 415.381-173.349C1360.85 305.432 1422.7 154.989 1422.66-1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m1422.66-1.86 363.8-.004c.01 527.697-425.73 955.49-950.914 955.492h-.561l-.005-363.904h.349c155.816-.05 305.231-62.406 415.381-173.349C1360.85 305.432 1422.7 154.989 1422.66-1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m1422.66-1.86 363.8-.004c.01 527.697-425.73 955.49-950.914 955.492h-.561l-.005-363.904h.349c155.816-.05 305.231-62.406 415.381-173.349C1360.85 305.432 1422.7 154.989 1422.66-1.86z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1603.73,
    y1: -16.938,
    x2: 154.8,
    y2: 1683.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBEB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.0bead62284ddda6f3eaafc4ca54682dd.svg";
export { ForwardRef as ReactComponent };